module.exports = __webpack_public_path__ + "img/solution-hmi-application-pic.3e4d8c7a.png";